export default {
  staticWrapperRoot: {
    minWidth: '215px !important',
  },
};
